import React, { useEffect, useState } from 'react'
import { Document, Page, Text, View, StyleSheet, Font,  Image } from '@react-pdf/renderer';
import { calcularEdad } from '../../../../hooks/UseDate';
import { postInformacionEmpresa } from '../../../../services/PaginaRuta';
// Registro de fuente personalizada
Font.register({
    family: 'Open Sans',
    fonts: [
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf', fontWeight: 800 }
    ]
  })

 

  const styles = StyleSheet.create({
    page: {
      padding: 30,
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    column: {
      width: '50%',      
      fontSize: 10
    },
    bold:{
      fontFamily: 'Open Sans',
      fontWeight: 800
    },
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none",      
    }, 
    tableRow: {       
      flexDirection: "row" 
    }, 
    
    tableCell: { 
      width: "12.5%",
      padding: '3px',      
      fontSize: 8 
    },
    
    tableCellLarge:{
      width: "50%",
      padding: '3px',      
      fontSize: 8 
    },
    
    
    tableCellOtrosParticipantes: { 
      width: "25%",
      padding: '3px',      
      fontSize: 8 
    },
    columnMedico:{
      width: '50%',      
      fontSize: 8
    },
    textBox: {
      padding: 10,
      backgroundColor: '#e0e0e0',  // color gris
      fontSize: 9,
      marginTop: 3, // Agregar margen en la parte superior de la fila
      marginBottom: 3, // Agregar margen en la parte inferior de la fila
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 60, 
      height: 60, 
      margin: '25px',
    },

    
  });
const PDFNotaQx = ({dataProcedimientos, user, dataAnestesiologo, textNota}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [informacionEmpresa,setinformacionEmpresa]=useState({
          EMPCOD: "",
            EmpNit: "",
            EmpRazSoc: "",
            MCDnom: "",
            MCDpto: "",
            T2_EMPCOD: "",
    
        })
  useEffect(()=>{
    const datosEmpresa={
                "EMPCOD":usuarioInfo.Empresa,
                "MCDpto":usuarioInfo.Sede
            }
            postInformacionEmpresa(datosEmpresa).then((res)=>{      
                if(res.data[0]){
                  setinformacionEmpresa(res.data[0])
                  console.log(res.data,'datos empresaa')
                }
                
              })
  },[])

  // ------------------------------------------------------------
// Decorator + SRP: validación y envoltura de <Image> con casos comunes
// ------------------------------------------------------------
const ValidatedImage = ({ src, style }) => {
  if (typeof src !== 'string') {              // 1. Guard Clause: descarta si no es cadena
    return null;                              //    -> no renderiza nada
  }
  const trimmed = src.trim();                 // 2. Limpia espacios en blanco innecesarios
  let uri = trimmed;                          // 3. Asume el valor limpio como URI inicial

  // 4. Si no es un data URI, puede ser puro Base64 sin prefijo
  if (!trimmed.startsWith('data:')) {         
    // 4.1 Verifica que contenga solo caracteres Base64 válidos
    if (/^[A-Za-z0-9+/]+={0,2}$/.test(trimmed)) {
      // 4.2 Agrega prefijo asumiendo PNG (puedes cambiar a jpeg si lo requieres)
      uri = {trimmed};
    } else {
      return null;                            // 4.3 Guard Clause: descarta si no es Base64 puro
    }
  }

  // 5. Asegura que ahora sí sea un data URI de imagen
  if (!uri.startsWith('data:image/')) {       
    return null;                              //    -> descarta si es otro tipo de data URI
  }

  // 6. Finalmente renderiza la imagen con el estilo que le pases
  return <Image src={uri} style={style} />;
};
  return (
    <Document>
      <Page size="A4" style={styles.page}>
      {/* <Image style={styles.image} src={logo} /> */}
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpRazSoc? informacionEmpresa.EmpRazSoc.trim():null}</Text>   
        {/* <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.MCDnom? informacionEmpresa.MCDnom.trim():null}</Text> */}
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpNit? informacionEmpresa.EmpNit.trim():null}</Text> 
        {/* <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.MDNomM? dataDescripcionQx.MDNomM.trim():null} - {dataDescripcionQx.MDNomD? dataDescripcionQx.MDNomD.trim():null}</Text>  */}
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DESCRIPCIÓN DE CIRUGÍAS</Text> 
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Paciente:</Text> {user.MPNOMC?user.MPNOMC.trim():null}</Text>
            <Text><Text style={styles.bold}>Edad:</Text> {user.MPFchN?calcularEdad(user.MPFchN.split(" ")[0] ):null} Años</Text>
            <Text><Text style={styles.bold}>Sala:</Text> {user.ProNcons? user.ProNcons.trim():null}</Text>            
          </View>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Identificación:</Text> {user.MPTDoc}-{user.MPCedu? user.MPCedu.trim():null}</Text>
            <Text><Text style={styles.bold}>Empresa:</Text> {user.ProEPS?user.ProEPS.trim():null}</Text>
            <Text><Text style={styles.bold}>Fecha programación de cirugía:</Text> {user.ProFec? user.ProFec.split(' ')[0]:null}</Text>
          </View>          
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5,  marginTop:5}}/>
        <View style={styles.container}>
          <View style={styles.column}>
            {/* <Text><Text style={styles.bold}>Sede de Atención:</Text> {dataDescripcionQx.MCDnom?dataDescripcionQx.MCDnom.trim():null}</Text> */}
                                     
          </View>
          <View style={styles.column}>
            
          </View>          
        </View>
        <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>CIRUGÍAS</Text></Text>
        <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>CÓDIGO</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>NOMBRE DE LA CIRUGÍA</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>CANTIDAD </Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>GRUPO QUIRÚRGICO</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>UVR</Text> 
                  </View>
                </View>
                 { 
                     dataProcedimientos.map((item,index)=>( 
                        <>
                        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                        <View style={styles.tableRow} key={index} >
                            <View style={styles.tableCell}> 
                                <Text >{item.CrgCod}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                              <Text>{item.CrgDes?.trim() ?? null}</Text>                                
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.CrgCnt}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.ForLiqCod}</Text> 
                            </View>     
                            <View style={styles.tableCell}> 
                                <Text >{item.PTCntUvr?item.PTCntUvr:null}</Text> 
                            </View>                          
                        </View>
                        <View style={styles.container}>
                          <View style={styles.columnMedico}>
                          <Text><Text style={styles.bold}>Cirujano:</Text> {item.MedNom?.trim() ?? null}</Text>
                          <Text><Text style={styles.bold}>Vía:</Text> {item.ViaDsc?item.ViaDsc.trim():null}</Text>
                          </View>
                          <View style={styles.columnMedico}>
                          <Text><Text style={styles.bold}>Especialidad:</Text> {item.EspcDes?item.EspcDes.trim():null}</Text>
                          </View>
                          
                        </View>
                        </>
                     )) 
                 } 
        </View>
              <View >
                <Text style={{marginTop:15}}></Text>
                <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>DESCRIPCIÓN CIRUGÍA </Text></Text>
                <Text style={{ fontSize: 10,paddingTop: '3px'}}><Text style={styles.bold}>Nombre  :</Text>  {dataAnestesiologo.MMNomM}</Text>
                <Text style={{ fontSize: 10, paddingTop: '3px'}}><Text style={styles.bold}>Especialidad :</Text>  {dataAnestesiologo.MENomE}</Text>
                <Text style={{ fontSize: 10,paddingTop: '3px',fontFamily: 'Open Sans',fontWeight: 900}}>Descripcion :</Text>
                <Text style={{ fontSize: 10,}}>{textNota? textNota:''}</Text>
                
              </View>
             
            
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        {/* <Image src={dataAnestesiologo.MMFIRMA} style={{ width: 100, height: 50, alignSelf: 'center', margin: 5 }} /> */}
        <ValidatedImage src={dataAnestesiologo.MMFIRMA} style={{ width: 100, height: 50, alignSelf: 'center', margin: 5 }} />
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataAnestesiologo.MMNomM?dataAnestesiologo.MMNomM.trim():null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataAnestesiologo.MENomE? dataAnestesiologo.MENomE.trim():null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>*** FIN DEL REPORTE ***</Text>   
      </Page>
    

   
  </Document>
  )
}

export default PDFNotaQx